import { Faq } from 'shared/components/Faq';
import type { TFaqItem } from 'shared/types/faq';

interface IFaqContainerProps {
  items: TFaqItem[];
}

export const FaqContainer: React.FC<IFaqContainerProps> = ({ items }) => {
  return <Faq items={items} />;
};
